import styled from '@emotion/styled';
import themeGet from '@styled-system/theme-get';

export const StyledApiIntegrationsBlockWrapper = styled.div`
  .styled-row {
    max-width: none;
    margin-left: 1rem;
    margin-right: 1rem;
    padding-left: 0;
    padding-right: 0;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    .styled-row {
      margin-left: 11rem;
      margin-right: 11rem;

    }  
  }
`

export const StyledApiIntegrationsBlock = styled.article`  
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  h2 {
    color: #4A6592;
    font-size: 20px;
    margin-bottom: 34px;
    font-weight: 700;
  }

  .title-hr {
    border: 1px solid #E1E3EA;
    margin-bottom: 51px;
  }

  p {
    font-size: 16px;
    font-weight: 325;
    line-height: 30px;
  }

  #partners {
    width: 100%;

    img {
      margin-bottom: 1rem;
    }

    .partners__cta {
      margin-bottom: 50px;
    }
  }

  #platforms {
    width: 100%;

    a {
      position: relative;
    }

    svg {
      position: absolute;
      bottom: 16px;
      right: 9px;
    }
  }
  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin-top: 0;

    #partners, #platforms {
      width: 46%;
    }

  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) and (max-width: 1580px) {
  }
`;

export const StyledCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const StyledCard = styled.a`
  color: #3368fa;
  box-shadow: 0 0 1px 0 #a8b9d5, 0 12px 24px -6px #ebf2ff;
  background: #fff;
  border-radius: 3px;
  width: 48%;
  margin-bottom: 4%;
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  padding: 26px;

  img{
    align-item: center;
  }

`;